import { Link } from "react-router-dom";

export default function ModerationAddendum({ addendum, as: Tag = "span" }) {
  if (!addendum) return null;
  return (
    <Tag className="moderation-nudge">
      {addendum.text}
      {addendum.actionLabel && (
        <Link to={addendum.actionPath} className="error-banner-link">{addendum.actionLabel}</Link>
      )}
    </Tag>
  );
}
